import * as React from 'react'
import { View, Text } from 'react-native'
import styled from '@theme/styled-components'

interface Props {
  service: SocieteResponse
}

const ServiceCard = ({ service }: Props) => {
  return (
    <MainContainer>
      <TopContainer>
        <Name numberOfLines={1} ellipsizeMode="tail">
          {service.nameSociete}
        </Name>
      </TopContainer>

      <BottomContainer>
        <Info numberOfLines={1} ellipsizeMode="tail">
          {service.codeSociete}
        </Info>
      </BottomContainer>
    </MainContainer>
  )
}

export default ServiceCard

const MainContainer = styled(View)`
  ${(props) => props.theme.breakpoint !== 'phone' && `width: 360px;`}
  ${(props) => props.theme.constants.shadow};
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.incident};
  overflow: hidden;
`

const TopContainer = styled(View)`
  padding: 16px 24px;
  background-color: ${(props) => props.theme.colors.background};
`

const Name = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
`

const Info = styled(Text)`
  ${(props) => props.theme.fonts.Option};
`

const BottomContainer = styled(View)`
  padding: 16px 24px;
`
